import { formatDateTime } from "../../../../../utils/DateUtils";

export const renderMedicalHistoryEntry = (medicalHistory, patientHistory) => {
  const updateTime = [];

  const parts = [];
  if (medicalHistory?.code?.text) {
    parts.push(medicalHistory.code.text);
  }

  if (medicalHistory?.severity?.text) {
    parts.push(medicalHistory.severity.text);
  }

  if (medicalHistory?.clinicalStatus?.text) {
    parts.push(medicalHistory.clinicalStatus.text);
  }

  if (medicalHistory?.verificationStatus?.text) {
    parts.push(medicalHistory.verificationStatus.text);
  }

  if (medicalHistory.onset?.value && medicalHistory.onset?.unit) {
    parts.push(`${medicalHistory.onset.value} ${medicalHistory.onset.unit}`);
  }

  if (medicalHistory?.note?.length > 0) {
    medicalHistory.note.forEach((n) => {
      parts.push(`${n.text}`);
    });
  }

  if (medicalHistory?.meta?.lastUpdated) {
    updateTime.push(formatDateTime(medicalHistory.meta.lastUpdated));
  }

  return <>{`⚬ ${parts.join(" · ")}`}</>;
};
